
const SEOMeta = {
    install(Vue) {
        Vue.prototype.$seo = {
            apply(settings) {
                if (!Array.isArray(settings)) return;

                const getVal = (id) => {
                    const s = settings.find(x => x.id === id);
                    return s ? s.value : '';
                };

                const title = getVal('storeName') || 'ERP Store';
                const seoTitleSuffix = getVal('seoTitle') || '';
                const fullTitle = seoTitleSuffix ? `${title} - ${seoTitleSuffix}` : title;

                const description = getVal('seoDescription') || '';
                const keywords = getVal('seoKeywords') || '';

                const logo = getVal('systemLogo') || '';
                let logoUrl = '';
                if (logo) {
                    if (logo.startsWith('http') || logo.startsWith('data:')) {
                        logoUrl = logo;
                    } else {
                        logoUrl = window.location.origin + '/img/' + logo;
                    }
                }

                document.title = fullTitle;

                // Update Favicon
                if (logo) {
                    let favicon = document.querySelector('link[rel="icon"]');
                    if (!favicon) {
                        favicon = document.createElement('link');
                        favicon.rel = 'icon';
                        document.head.appendChild(favicon);
                    }
                    favicon.href = logoUrl;
                }

                // Update Apple Touch Icon
                if (logo) {
                    let appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
                    if (!appleIcon) {
                        appleIcon = document.createElement('link');
                        appleIcon.rel = 'apple-touch-icon';
                        document.head.appendChild(appleIcon);
                    }
                    appleIcon.href = logoUrl;
                }

                // Meta Helper
                const updateMeta = (name, content, attribute = 'name') => {
                    if (!content) return;
                    let el = document.querySelector(`meta[${attribute}="${name}"]`);
                    if (!el) {
                        el = document.createElement('meta');
                        el.setAttribute(attribute, name);
                        document.head.appendChild(el);
                    }
                    el.setAttribute('content', content);
                };

                // Basic SEO
                updateMeta('description', description);
                updateMeta('keywords', keywords);

                // Twitter Card
                updateMeta('twitter:card', 'summary_large_image');
                updateMeta('twitter:site', getVal('twitterHandle'));
                updateMeta('twitter:title', title);
                updateMeta('twitter:description', description);
                updateMeta('twitter:image', logoUrl);

                // Open Graph / Facebook
                updateMeta('og:title', title, 'property');
                updateMeta('og:type', 'website', 'property');
                updateMeta('og:url', window.location.href, 'property');
                updateMeta('og:image', logoUrl, 'property');
                updateMeta('og:description', description, 'property');
                updateMeta('og:site_name', getVal('companyName') || title, 'property');

                // JSON-LD
                const companyName = getVal('companyName');
                if (companyName) {
                    let script = document.getElementById('json-ld-schema');
                    if (!script) {
                        script = document.createElement('script');
                        script.id = 'json-ld-schema';
                        script.type = 'application/ld+json';
                        document.head.appendChild(script);
                    }

                    const socialLinks = (getVal('socialLinks') || '').split('\n').filter(s => s.trim() !== '');

                    const schema = {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": companyName,
                        "url": getVal('companyUrl') || window.location.origin,
                        "logo": logoUrl,
                        "description": description,
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": getVal('contactPhone'),
                            "contactType": "customer service",
                            "email": getVal('contactEmail')
                        },
                        "sameAs": socialLinks
                    };
                    script.text = JSON.stringify(schema, null, 2);
                }

                // Footer / analytics scripts
                // We parse and append script tags safely so malformed snippets do not break the app.
                const footerScripts = getVal('footerJs');
                if (footerScripts && !document.getElementById('custom-footer-scripts')) {
                    const host = document.body || document.documentElement;
                    if (host) {
                        const container = document.createElement('div');
                        container.id = 'custom-footer-scripts';

                        try {
                            const template = document.createElement('template');
                            template.innerHTML = footerScripts;
                            Array.from(template.content.childNodes).forEach((node) => {
                                if (node.nodeType === 1 && node.tagName === 'SCRIPT') {
                                    const source = (node.textContent || '').trim();
                                    const scriptType = String(node.getAttribute('type') || '').toLowerCase();
                                    const isModuleScript = scriptType === 'module';
                                    if (!node.src && source && !isModuleScript) {
                                        try {
                                            // Validate inline syntax first to avoid runtime parse crashes.
                                            // eslint-disable-next-line no-new-func
                                            new Function(source);
                                        } catch (err) {
                                            console.warn('Invalid footer inline script skipped:', err && err.message ? err.message : err);
                                            return;
                                        }
                                    }

                                    const scriptEl = document.createElement('script');
                                    Array.from(node.attributes || []).forEach((attr) => {
                                        scriptEl.setAttribute(attr.name, attr.value);
                                    });
                                    if (!node.src) {
                                        scriptEl.text = node.textContent || '';
                                    }
                                    container.appendChild(scriptEl);
                                } else {
                                    container.appendChild(node.cloneNode(true));
                                }
                            });
                        } catch (err) {
                            console.warn('Failed to parse footer scripts setting:', err && err.message ? err.message : err);
                        }

                        host.appendChild(container);
                    }
                }

                // Analytics Pixels
                const pixelIds = {
                    ga: getVal('googleAnalytics'),
                    fb: getVal('facebookPixel'),
                    tw: getVal('twitterPixel')
                }

                if (pixelIds.ga) {
                    // Simple Google Tag injection
                    if (!document.getElementById('ga-script')) {
                        const s = document.createElement('script');
                        s.id = 'ga-script';
                        s.async = true;
                        s.src = `https://www.googletagmanager.com/gtag/js?id=${pixelIds.ga}`;
                        document.head.appendChild(s);

                        const s2 = document.createElement('script');
                        s2.text = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${pixelIds.ga}');`;
                        document.head.appendChild(s2);
                    }
                }
            }
        };
    }
};

export default SEOMeta;
